import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconFileCode: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.1082 7.05833L12.1082 2.05833C11.9907 1.94083 11.8323 1.875 11.6665 1.875H6.6665C4.6515 1.875 3.5415 2.985 3.5415 5V15C3.5415 17.015 4.6515 18.125 6.6665 18.125H14.1665C16.1815 18.125 17.2915 17.015 17.2915 15V7.5C17.2915 7.33417 17.2257 7.175 17.1082 7.05833ZM12.2915 4.00917L15.1573 6.875H14.1665C12.8523 6.875 12.2915 6.31417 12.2915 5V4.00917ZM14.1665 16.875H6.6665C5.35234 16.875 4.7915 16.3142 4.7915 15V5C4.7915 3.68583 5.35234 3.125 6.6665 3.125H11.0415V5C11.0415 7.015 12.1515 8.125 14.1665 8.125H16.0415V15C16.0415 16.3142 15.4807 16.875 14.1665 16.875ZM8.77486 12.1083L7.54989 13.3333L8.77486 14.5583C9.01903 14.8025 9.01903 15.1983 8.77486 15.4425C8.65319 15.5642 8.49317 15.6258 8.33317 15.6258C8.17317 15.6258 8.01315 15.565 7.89148 15.4425L6.22481 13.7758C5.98065 13.5317 5.98065 13.1358 6.22481 12.8917L7.89148 11.225C8.13565 10.9808 8.53151 10.9808 8.77567 11.225C9.01984 11.4692 9.01903 11.8642 8.77486 12.1083ZM12.9415 12.8917C13.1857 13.1358 13.1857 13.5317 12.9415 13.7758L11.2749 15.4425C11.1532 15.5642 10.9932 15.6258 10.8332 15.6258C10.6732 15.6258 10.5131 15.565 10.3915 15.4425C10.1473 15.1983 10.1473 14.8025 10.3915 14.5583L11.6165 13.3333L10.3915 12.1083C10.1473 11.8642 10.1473 11.4683 10.3915 11.2242C10.6356 10.98 11.0315 10.98 11.2757 11.2242L12.9415 12.8917Z" fill={color} />
  </svg>
);

export default IconFileCode;
